import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';
import { TableSkeleton } from '@/components/ui/skeleton';

const SettingsChannelsPage = lazy(() => import('@/pages/settings/channels'));

export const Route = createFileRoute('/settings/channels')({
  component: function SettingsChannelsRoute() {
    return (
      <Suspense fallback={<TableSkeleton />}>
        <SettingsChannelsPage />
      </Suspense>
    );
  },
});
